(function () {
    'use strict';

    angular
        .module('invoices')
        .controller('InvoicesUserController', InvoicesUserController);

    InvoicesUserController.$inject = ['$state', '$stateParams', '$filter', '$sce', 'InvoicesService'];

    function InvoicesUserController($state, $stateParams, $filter, $sce, InvoicesService) {
        var vm = this;

        vm.invoice_type = $state.current.data.invoice_type;
        vm.title = $state.current.data.title;

        vm.expo_id;

        vm.message = null;
        vm.classMessage = null;

        vm.user = [];
        vm.getUser = getUser;

        vm.getFinancialStatusLabel  = getFinancialStatusLabel;
        vm.getFinancialStatusClass  = getFinancialStatusClass;
        vm.getInvoiceStatusLabel    = getInvoiceStatusLabel;
        vm.getInvoiceStatusClass    = getInvoiceStatusClass;
        vm.remove                   = remove;
        vm.sendToSeller             = sendToSeller;
        vm.sendToCustomer           = sendToCustomer;

        activate();

        function activate() {
            InvoicesService.setData(null);  

            if ($stateParams.hasOwnProperty('id')) {                         
                vm.getUser($stateParams.id);                
            }                            
        }


        function getUser(user_id) {
            vm.query = {};

            if ($stateParams.hasOwnProperty('expo_id')) {                         
                vm.query['expo_id'] = $stateParams.expo_id;
                vm.expo_id = $stateParams.expo_id;
            }

            if ($stateParams.hasOwnProperty('virtual_fair_id')) {                         
                vm.query['virtual_fair_id'] = $stateParams.virtual_fair_id;
                vm.expo_id = $stateParams.virtual_fair_id;
            }

            InvoicesService.getUserInvoices(user_id, vm.query, vm.invoice_type).then(function(response) {
                vm.user = response.data;

                if ($stateParams.hasOwnProperty('invoice_created') && $stateParams.invoice_created != undefined) {
                    var invoice = $filter('filter')(vm.user['exhibitor'].invoices, {id: $stateParams.invoice_created})[0];                       

                    vm.message = $sce.trustAsHtml('<strong>Success!</strong> Invoice has been sent! <a href="' + invoice.url + '" class="alert-link" target="_Blank">Click here</a> to see the invoice.');
                    vm.classMessage = 'alert-success';
                }

                if ($stateParams.hasOwnProperty('invoice_updated') && $stateParams.invoice_updated != undefined) {
                    var invoice = $filter('filter')(vm.user['exhibitor'].invoices, {id: $stateParams.invoice_updated})[0];                       

                    vm.message = $sce.trustAsHtml('<strong>Success!</strong> Invoice has been updated! <a href="' + invoice.url + '" class="alert-link" target="_Blank">Click here</a> to see the invoice.');
                    vm.classMessage = 'alert-success';
                }

                if ($stateParams.hasOwnProperty('errors') && $stateParams.errors != undefined) {              
                    vm.message = $sce.trustAsHtml('<strong>Sorry!</strong> ' + $stateParams.errors);
                    vm.classMessage = 'alert-danger';
                }
            }).catch(function(err) {
            });
        }


        function getFinancialStatusLabel(status) {
            if (status === 'waiting_invoice')
                return 'Pending';
            else if (status === 'invoice_created')
                return 'Created';
            else if (status === 'invoice_paid')
                return 'Paid';
        }


        function getFinancialStatusClass(status) {
            if (status === 'waiting_invoice')
                return 'label-danger';
            else if (status === 'invoice_created')
                return 'label-warning';
            else if (status === 'invoice_paid')
                return 'label-success';
        }

        function getInvoiceStatusLabel(status, due_date) {
            if (status === 'paid')
                return 'Paid';
            else { 
                var now = new Date();
                due_date = new Date(due_date);

                if (now > due_date)               
                    return 'Overdue';   
            }
            
            return 'Waiting Payment';
            
        }


        function getInvoiceStatusClass(status, due_date) {
            if (status === 'paid')
                return 'label-success';
            else {
                var now = new Date();
                due_date = new Date(due_date);

                if (now > due_date)
                    return 'label-danger';                
            }

            return 'label-warning';
        }

        function remove(invoice) {
            alertify
                .confirm('This action is irreversible!')
                .set('labels', {
                    ok: 'Ok',
                    cancel: 'Cancelar'
                })
                .set('title', 'Do you really want to delete this invoice?')
                .set('onok', function (){
                    InvoicesService.destroy(invoice.id).then(function() {
                        vm.user['exhibitor'].invoices.splice(vm.user['exhibitor'].invoices.indexOf(invoice), 1);
                        alertify.notify('Invoice removed', 'success', 3);

                        vm.message = null;
                        vm.classMessage = null;
                        vm.getUser($stateParams.id);
                    });
                })
                .show();
        }

        function sendToCustomer(invoice) {
            alertify
                .confirm('Do you really want to send this invoice to ' + invoice.contact_email + '?')
                .set('labels', {
                    ok: 'Ok',
                    cancel: 'Cancelar'
                })
                .set('title', 'Alert!')
                .set('onok', function (){
                    InvoicesService.sendInvoiceToCustomer(invoice.id).then(function() {                        
                        alertify.notify('Invoice sent!', 'success', 3);
                    });
                })
                .show();
        }

        function sendToSeller(invoice) {
            alertify
                .confirm('Do you really want to send this invoice to ' + invoice.seller_email + '?')
                .set('labels', {
                    ok: 'Ok',
                    cancel: 'Cancelar'
                })
                .set('title', 'Alert!')
                .set('onok', function (){
                    InvoicesService.sendInvoiceToSeller(invoice.id).then(function() {                        
                        alertify.notify('Invoice sent!', 'success', 3);
                    });
                })
                .show();
        }
    }

})();